import {
  Grid,
  Box,
  Button,
  CircularProgress,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import UploadFile from "../../UploadFile";
import { Controller, useFormContext } from "react-hook-form";
import { TDetalheProcessoFormularioDyn } from "../../../types/api/bpm/detalhar-processo";
import DynamicFormHandler from "../../DynamicFormHandler";
import TableMenuOptions from "../../TableMenuOptions";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

export default function TarefaTipoCondicional({
  handleClick,
  handleClickDevolver,
  isLoading,
  formularioDyn,
  opcoes = [],
  precisaFormulario,
  solicitantePodeRealizar,
  extras,
}: TarefaTipoCondicionalProps) {
  const { control, getValues, handleSubmit, watch, reset } = useFormContext();
  
  const handleConfirm = () => {
    const { observacoes, anexos, resposta } = getValues();

    const param: any = {
      resposta,
    };
    formularioDyn?.spec.forEach((item) => {
      const valor = getValues(item.name);
      param[item.name] = valor;
    });

    const jsonParam = JSON.stringify(param);

    handleClick(observacoes, anexos, jsonParam);
    reset();
  };

  const resposta: string = watch("resposta");
  const openForm = precisaFormulario?.find((e) => e === resposta);

  return (
    <>
      {solicitantePodeRealizar && (
        <Box display="flex" flexDirection="column">
          <Controller
            name="resposta"
            control={control}
            rules={{ required: "Campo obrigatório" }}
            render={({ field }) => (
              <RadioGroup
                {...field}
                row
                name="row-radio-buttons-group"
                aria-labelledby="demo-row-radio-buttons-group-label"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  field.onChange((event.target as HTMLInputElement).value);
                }}
              >
                {opcoes.map((i: any) => (
                  <FormControlLabel value={i} control={<Radio />} label={i} />
                ))}
              </RadioGroup>
            )}
          />

          {openForm &&
            formularioDyn &&
            formularioDyn.spec.map((item, index) => (
              <DynamicFormHandler {...{ extras }} key={index} spec={item} />
            ))}

          <Controller
            name="observacoes"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                margin="normal"
                label="Observações"
                multiline
                minRows={2}
                variant="outlined"
              />
            )}
          />

          <Grid container spacing={2}>
            <Grid size={{ xs: 6 }}>
              <Controller
                name={"anexos"}
                control={control}
                render={({ field }) => (
                  <UploadFile
                    values={field.value}
                    onChangeValues={(arquivos) => field.onChange(arquivos)}
                    type="tarefa"
                    btnActionsList={[
                      <Button
                        disabled={
                          watch("resposta") !== undefined
                            ? false
                            : true || isLoading
                        }
                        variant="contained"
                        onClick={handleSubmit(handleConfirm)}
                        style={{ width: 130 }}
                      >
                        {isLoading && (
                          <CircularProgress
                            size={14}
                            style={{ marginRight: 12 }}
                          />
                        )}
                        Resolver
                      </Button>,
                    ]}
                  />
                )}
              />
            </Grid>

            <Grid
              size={{ xs: 6 }}
              alignSelf="flex-end"
              style={{ textAlign: "right" }}
            >
              <TableMenuOptions
                menuItems={[
                  {
                    label: "Devolver tarefa",
                    icon: <RestartAltIcon color="error" />,
                    action: handleClickDevolver,
                  },
                ]}
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  );
}

interface TarefaTipoCondicionalProps {
  isLoading: boolean;
  opcoes?: Array<string>;
  formularioDyn: TDetalheProcessoFormularioDyn | null;
  handleClick: (obs: string, anexos: File[], resposta: string) => void;
  handleClickDevolver: () => void;
  precisaFormulario: string[];
  solicitantePodeRealizar: boolean;
  extras: any;
}
